import http from "../../http";

export default {
  page(params) {
    return http.get("activityservice/video/subject/page", params);
  },
  save(params) {
    return http.post("activityservice/video/subject/save", params);
  },
  del(params) {
    return http.get("activityservice/video/subject/delete/id", params);
  }
};
